import { CascaderSelect } from '@alifd/next';
import { getStructureFieldName } from '../utils';
import { useComponentContext } from '../../context/useComponentContext';
const React = window.React;
const { createElement, useEffect, useRef, useState } = React;
const ProCascaderSelect = (props) => {
    const { screen_structure, screen_structure_field, screen_inner_id, dataSource, defaultValue, disableEdit, ...otherProps } = props;
    const { structureName, structureField } = getStructureFieldName(screen_structure, screen_structure_field);
    const fieldPath = `${structureName}.${structureField}`;
    const { value, onValueChange } = useComponentContext(fieldPath);
    console.log('ProCascaderSelect useComponentContext value', value, fieldPath);
    const handleChange = (newValue) => {
        if (onValueChange) {
            onValueChange(newValue);
        }
        if (props.onChange) {
            props.onChange(newValue, structureName, structureField);
        }
    };
    return (createElement("span", { className: `field-wrapper ${disableEdit ? 'disable-edit' : 'enable-edit'}` },
        createElement(CascaderSelect, { ...props, value: value, onChange: handleChange, dataSource: dataSource })));
};
export default ProCascaderSelect;
